export default __webpack_public_path__ + "static/media/carpet-cleaning.8bdc8925.jpg";